import { FC, Fragment, useEffect, useRef, useState } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Transition,
  Dialog,
  TransitionChild,
  DialogPanel,
  DialogTitle,
  Button,
  Checkbox,
} from "@headlessui/react";
import { useData } from "data/data-provider";
import { cancelBooking, retriveBooking } from "api/booking/booking";
import toast from "react-hot-toast";
import { globalJson } from "global/global_json";
import { encodeBase64 } from "@progress/kendo-file-saver";
import {
  getPrivacyPolicyContent,
  sendRentalAgreement,
} from "api/rental-agreement/rental-agreement";
import { Squares2X2Icon, XMarkIcon } from "@heroicons/react/24/solid";
import moment from "moment";
import {
  CreateStripeVerification,
  CreateVouchVerification,
} from "api/stripe/stripe";
import { CreateCanopyVerification } from "api/Canopy/canopy";
import { CanopyPayload } from "api/types";
import Badge from "shared/Badge/Badge";
import { getBonzahPDF, getBonzahProducts } from "api/bonzah/bonzah";
import {
  formatDateToHumanFirendly,
  formatTimeToHumanFirendly12Hour,
  formatTimeToHumanFirendly24Hour,
} from "utils/date-format";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";
import PhoneNumberDisplay, { formatPhoneLabel } from "utils/PhoneFormat";
import EditBooking from "../EditBooking/EditBooking";
import UploadZone from "designs/Common/upload/upload";
import PreviousBookings from "../PreviousBookings/PreviousBooking";
import RenterInfo from "../EditBooking/RenterInfo";
import ConnectedBookings from "../ConnectedBookings/ConnectedBookings";
import { formatPrice } from "utils/convertNumbThousand";
import DetailPagetLayout from "./Layout";
import {
  CheckIcon,
  ExclamationTriangleIcon,
} from "@heroicons/react/24/outline";
import Cancellation from "../CheckOutPage/Cancellation";

export interface bookingDetailPageProps {
  className?: string;
}

const BookingDetailPage: FC<bookingDetailPageProps> = ({ className = "" }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    ourCompany,
    setPickupLocation,
    setSelectedExtras,
    setSelectedBonzahProducts,
    selectedCar,
    setSearchedDropoffLocation,
    setSearchedPickupLocation,
    setSelectedCar,
    setDropoffLocation,
    setEndDate,
    setStartDate,
    setDropoffLocationType,
    setStartTime,
    startTime,
    setEndTime,
    endTime,
  } = useData();

  const queryParams = new URLSearchParams(location.search);
  let bookingId = queryParams.get("id");

  const [bookingloading, setBookingLoading] = useState(true);
  const [isTotalBillModalOpen, setIsTotalBillModalOpen] = useState(false);
  let [isOpen, setIsOpen] = useState(false);
  let [bookingDetails, setBookingDetail] = useState<any | null>(null);
  const [isPreTrip, setIsPreTrip] = useState<boolean>(true);
  const [canopyLoading, setCanopyLoading] = useState(false);
  const [identityLoading, setIdentityLoading] = useState(false);
  const [drivercanopyLoading, setDriverCanopyLoading] = useState(false);
  const [driveridentityLoading, setDriverIdentityLoading] = useState(false);
  const [canopyLink, setCanopyLink] = useState<any>();
  const [identityLink, setIdentityLink] = useState<any>();
  const [drivercanopyLink, setDriverCanopyLink] = useState<any>();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [driveridentityLink, setDriverIdentityLink] = useState<any>();
  const [isEdit, setIsEdit] = useState(false);
  const [isRenterInfoEdit, setIsRenterInfoEdit] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [showImgGallery, setShowImgGallery] = useState(false);
  const [isCancellationPolicyModalOpen, setIsCancellationPolicyModalOpen] =
    useState(false);
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const [isCancelling, setIsCancelling] = useState(false);
  const [cancellationPolicyChecked, setCancellationPolicyChecked] =
    useState(false);
  const [isCancellationOpen, setIsCancellationOpen] = useState(false);
  const [privacyPolicy, setPrivacyPolicy] = useState();
  const [cancellationPolicy, setCancellationPolicy] = useState();
  const [loading, setLoading] = useState<boolean>(true);
  const [showCopyIdentity, setShowCopyIdentity] = useState(false);
  const [showCopyCanopy, setShowCopyCanopy] = useState(false);
  const [showCopyDriverIdentity, setShowCopyDriverIdentity] = useState(false);
  const [showCopyDriverCanopy, setShowCopyDriverCanopy] = useState(false);
  const [isGridOpen, setIsGridOpen] = useState(false);

  const handleOpenModalImageGallery = (index: number) => {
    if (bookingDetails?.fleet?.fleet_photos?.length === 0) {
      toast("No Images available for this fleet", {
        style: {
          background: "#fff3cd",
          color: "#856404",
        },
      });
    } else {
      setCurrentIndex(index);
      setIsOpenModal(true);
    }
  };

  const closeModal = () => {
    setIsOpenModal(false);
  };

  const handleCloseEdit = () => {
    setIsEdit(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const modifyBooking = async (bookingId: string) => {
    navigate(`/modify-booking/${bookingId}`);
    return;
  };

  const handleCancelBooking = async () => {
    if (!bookingId) return;
    if (cancellationPolicyChecked !== true) {
      toast.error("Please accept our Cancellation Policy");
      return;
    }
    setIsCancelling(true);
    try {
      const result = await cancelBooking(bookingId);

      if (result.error) {
        toast.error(result.error);
      } else {
        setIsCancelModalOpen(false);
        setIsEdit(false);
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    } catch (error) {
      toast.error("Failed to cancel booking");
    } finally {
      setIsCancelling(false);

      fetchBookingDetail();
    }
  };

  const handleOpenTotalBillModal = () => {
    setIsTotalBillModalOpen(true);
  };

  const handleCloseTotalBillModal = () => {
    setIsTotalBillModalOpen(false);
  };

  function close() {
    setIsOpen(false);
  }
  const closeGridModal = () => setIsGridOpen(false);

  useEffect(() => {
    const getContent = async () => {
      setLoading(true);
      try {
        const response = await getPrivacyPolicyContent();

        setCancellationPolicy(response.data.cancellation_policy);
        setPrivacyPolicy(response.data.privacy_policy);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching content", error);
      }
    };

    getContent();
  }, []);

  const openRentalAgreement = async () => {
    if (bookingId) {
      const encodedData = encodeBase64(bookingDetails?.customer?.email);
      const path = `${bookingDetails?.id}b6cr4${ourCompany?.company.id}b6cr4${encodedData}`;

      let url = "";

      if (process.env.REACT_APP_ENV === "dev") {
        url = "https://dev.1now.app/pdf?agreement=";
      } else if (process.env.REACT_APP_ENV === "stage") {
        url = "https://stage.1now.app/pdf?agreement=";
      } else {
        url = "https://1now.app/pdf?agreement=";
      }
      window.open(`${url}${path}`, "_blank");
    }
  };

  function extractSubstringInBrackets(input: string) {
    if (typeof input !== "string") {
      throw new Error("Input must be a string.");
    }
    const match = input.match(/\(([^)]+)\)/);
    return match ? match[1] : null;
  }

  const sendAgreementEmail = async (type: string) => {
    const encodedData = encodeBase64(bookingDetails?.customer?.email as string);

    const path = `${bookingDetails?.id}b6cr4${ourCompany?.company}b6cr4${encodedData}`;
    try {
      const data: any = await sendRentalAgreement(path, type);
      toast.success("Email successfully sent!");
    } catch (error: any) {
      toast.error(error.toString());
    }
  };

  const fetchBookingDetail = async () => {
    setBookingLoading(true);
    if (!bookingId) {
      toast.error("Booking ID is missing");
      setBookingLoading(false);
      return;
    }
    try {
      const data = await retriveBooking(bookingId);
      if (data.error) {
        throw new Error(data.error);
      }
      setBookingDetail(data);
      setBookingLoading(false);
    } catch (error) {
      toast.error("Booking Not Found");
      setBookingDetail(null);
      setBookingLoading(false);
    }
  };
  useEffect(() => {
    fetchBookingDetail();
  }, [bookingId]);

  useEffect(() => {
    if (bookingDetails && bookingDetails.trip_status !== "cancelled") {
      const modalShownKey = `cancellationPolicyShown_${bookingDetails.id}`;
      const hasBeenShown = localStorage.getItem(modalShownKey);

      if (
        !hasBeenShown &&
        (!bookingDetails.customer?.identity_verified ||
          !bookingDetails.customer?.insurance_verified)
      ) {
        setIsCancellationPolicyModalOpen(true);
        localStorage.setItem(modalShownKey, "true");
      }
    }
  }, [bookingDetails]);

  useEffect(() => {
    if (bookingDetails) {
      setDropoffLocationType(bookingDetails?.same_drop_off);
      setPickupLocation(bookingDetails?.pick_up_location);
      setSearchedPickupLocation(bookingDetails?.custom_pick_up_address);
      setSearchedDropoffLocation(bookingDetails?.custom_drop_off_address);
      setDropoffLocation(bookingDetails?.drop_off_location);
      setStartTime(
        formatTimeToHumanFirendly24Hour(bookingDetails?.pick_up_time),
      );
      setEndTime(
        formatTimeToHumanFirendly24Hour(bookingDetails?.drop_off_time),
      );
      setStartDate(
        new Date(formatDateToHumanFirendly(bookingDetails?.pick_up_time)),
      );
      setEndDate(
        new Date(formatDateToHumanFirendly(bookingDetails?.drop_off_time)),
      );
      setSelectedCar(bookingDetails?.fleet);
      if (bookingDetails?.extras?.length > 0) {
        const extraIds = new Set<number>(
          bookingDetails.extras.map((extra: any) => extra.id),
        );
        setSelectedExtras(extraIds);
      }

      if (bookingDetails?.bonzah_insurance_options?.length > 0) {
        const insuranceIds = bookingDetails?.bonzah_insurance_options?.map(
          (insurance: any) => insurance,
        );
        setSelectedBonzahProducts(insuranceIds);
      }
    }
  }, [isEdit]);

  // Handle browser back button to navigate to home
  useEffect(() => {
    // Push a new state when component mounts, preserving query params
    window.history.pushState(
      null,
      "",
      window.location.pathname + window.location.search,
    );

    const handlePopState = (event: PopStateEvent) => {
      // Prevent default back behavior and navigate to home
      window.history.pushState(
        null,
        "",
        window.location.pathname + window.location.search,
      );
      navigate("/");
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate]);

  const handleCanopyVerificationButtonClick = async () => {
    setCanopyLoading(true);
    const payload: CanopyPayload = {
      user_id: bookingDetails?.customer?.id ?? "",
    };
    const IgnitionResponse = (await CreateCanopyVerification(payload)) as {
      data?: { insurance_verification_link?: string };
      error?: string;
    };
    if (
      IgnitionResponse.data &&
      IgnitionResponse.data.insurance_verification_link
    ) {
      const ignitionUrl = IgnitionResponse.data.insurance_verification_link;
      setCanopyLink(ignitionUrl);
      setCanopyLoading(false);
      return;
    } else {
      console.error(
        "Failed to retrieve insurance verification link:",
        IgnitionResponse.error,
      );
      toast.error("Verification failed. Please try again later.");
      setCanopyLoading(false);
    }
  };

  const handlePrimaryDriverVerificationButtonClick = async () => {
    setIdentityLoading(true);
    const payload = { customer_id: bookingDetails?.customer?.id ?? "" };
    if (ourCompany?.default_identity === "vouched") {
      const vouchSessionResponse = (await CreateVouchVerification(payload)) as {
        data?: { session_url?: string };
        error?: string;
      };
      if (vouchSessionResponse.data && vouchSessionResponse.data.session_url) {
        const sessionUrl = vouchSessionResponse.data.session_url;
        setIdentityLink(sessionUrl);
        setIdentityLoading(false);
        return;
      } else {
        console.error(
          "Failed to retrieve session URL:",
          vouchSessionResponse.error,
        );
        toast.error(
          vouchSessionResponse?.error ??
            "Verification failed. Please try again later.",
        );
        setIdentityLoading(false);
      }
    } else {
      const stripeSessionResponse = (await CreateStripeVerification(
        payload,
      )) as {
        data?: { session_url?: string };
        error?: string;
      };
      if (
        stripeSessionResponse.data &&
        stripeSessionResponse.data.session_url
      ) {
        const sessionUrl = stripeSessionResponse.data.session_url;
        setIdentityLink(sessionUrl);
        setIdentityLoading(false);
        return;
      } else {
        console.error(
          "Failed to retrieve session URL:",
          stripeSessionResponse.error,
        );
        toast.error(
          stripeSessionResponse?.error ??
            "Verification failed. Please try again later.",
        );
        setIdentityLoading(false);
      }
    }
  };
  const handleDriverCanopyVerificationButtonClick = async () => {
    setDriverCanopyLoading(true);
    const payload: CanopyPayload = {
      user_id: bookingDetails?.secondary_driver_obj?.id ?? "",
    };
    const IgnitionResponse = (await CreateCanopyVerification(payload)) as {
      data?: { insurance_verification_link?: string };
      error?: string;
    };
    if (
      IgnitionResponse.data &&
      IgnitionResponse.data.insurance_verification_link
    ) {
      const ignitionUrl = IgnitionResponse.data.insurance_verification_link;
      setDriverCanopyLink(ignitionUrl);
      setDriverCanopyLoading(false);
      return;
    } else {
      console.error(
        "Failed to retrieve insurance verification link:",
        IgnitionResponse.error,
      );
      toast.error("Verification failed. Please try again later.");
      setDriverCanopyLoading(false);
    }
  };

  const handleDriverPrimaryDriverVerificationButtonClick = async () => {
    setDriverIdentityLoading(true);
    const payload = {
      customer_id: bookingDetails?.secondary_driver_obj?.id ?? "",
    };
    let sessionUrl = "";
    if (ourCompany?.default_identity === "vouched") {
      const vouchSessionResponse = (await CreateVouchVerification(payload)) as {
        data?: { session_url?: string };
        error?: string;
      };
      if (vouchSessionResponse.data && vouchSessionResponse.data.session_url) {
        sessionUrl = vouchSessionResponse.data.session_url;
        setDriverIdentityLink(sessionUrl);
        setDriverIdentityLoading(false);
        return;
      } else {
        console.error(
          "Failed to retrieve session URL:",
          vouchSessionResponse.error,
        );
        toast.error("Verification failed. Please try again later.");
        setDriverIdentityLoading(false);
      }
    } else {
      const stripeSessionResponse = (await CreateStripeVerification(
        payload,
      )) as {
        data?: { session_url?: string };
        error?: string;
      };
      if (
        stripeSessionResponse.data &&
        stripeSessionResponse.data.session_url
      ) {
        sessionUrl = stripeSessionResponse.data.session_url;
        setDriverIdentityLink(sessionUrl);
        setDriverIdentityLoading(false);
        return;
      } else {
        console.error(
          "Failed to retrieve session URL:",
          stripeSessionResponse.error,
        );
        toast.error(
          stripeSessionResponse.error ??
            "Verification failed. Please try again later.",
        );
        setDriverIdentityLoading(false);
      }
    }
    setDriverIdentityLink(sessionUrl);
    setDriverIdentityLoading(false);
    // Try to open in new tab
    const newTab = window.open(sessionUrl, "_blank");
    if (!newTab) {
      setShowCopyDriverIdentity(true);
      toast("Popup blocked. Please copy the link manually.", {
        style: { background: "#fff3cd", color: "#856404" },
      });
    }
  };

  const renderImgSection = () => {
    return (
      <div>
        <header className="rounded-md sm:rounded-xl">
          <div className="relative grid grid-cols-1 md:grid-cols-4  gap-1 sm:gap-2 min-h-96 ">
            <div
              className="col-span-2 row-span-2 relative rounded-md sm:rounded-xl overflow-hidden cursor-pointer"
              onClick={() => {
                handleOpenModalImageGallery(0);
                setCurrentIndex(0);
              }}
            >
              <img
                src={
                  (bookingDetails?.fleet?.fleet_photos?.length ?? 0) > 0
                    ? bookingDetails?.fleet?.fleet_photos[0].photo_url.includes(
                        "http",
                      )
                      ? bookingDetails?.fleet?.fleet_photos[0].photo_url
                      : `https://fleet-management-images-upload-be.s3.amazonaws.com/${bookingDetails?.fleet?.fleet_photos[0].photo_url}`
                    : "https://tenant.fleetwire.io/images/vehicle-placeholder.jpg"
                }
                alt="0"
                className="absolute inset-0 object-cover rounded-md sm:rounded-xl w-full h-full"
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 50vw"
              />
              <div className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity"></div>
            </div>

            {/*  */}
            <div
              className="col-span-1 row-span-2 relative rounded-md sm:rounded-xl overflow-hidden cursor-pointer"
              onClick={() => {
                handleOpenModalImageGallery(1);
                setCurrentIndex(1);
              }}
            >
              <img
                className="absolute inset-0 object-cover rounded-md sm:rounded-xl w-full h-full"
                src={
                  (bookingDetails?.fleet?.fleet_photos?.length ?? 0) > 1
                    ? bookingDetails?.fleet?.fleet_photos[1].photo_url.includes(
                        "http",
                      )
                      ? bookingDetails?.fleet?.fleet_photos[1].photo_url
                      : `https://fleet-management-images-upload-be.s3.amazonaws.com/${bookingDetails?.fleet?.fleet_photos[1].photo_url}`
                    : "https://tenant.fleetwire.io/images/vehicle-placeholder.jpg"
                }
                alt="1"
                sizes="400px"
              />
              <div className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity"></div>
            </div>

            {/*  */}
            {bookingDetails?.fleet?.fleet_photos
              .filter((_: any, i: any) => i >= 2 && i < 4)
              .map((item: any, index: any) => (
                <div
                  key={index}
                  className={`relative rounded-md sm:rounded-xl overflow-hidden ${
                    index >= 2 ? "block" : ""
                  }`}
                >
                  <div className="aspect-w-4 aspect-h-3">
                    <img
                      className="absolute inset-0 object-cover w-full h-full rounded-md sm:rounded-xl "
                      src={
                        item.photo_url.includes("http")
                          ? item.photo_url
                          : `https://fleet-management-images-upload-be.s3.amazonaws.com/${item.photo_url}`
                      }
                      alt="photos"
                      sizes="400px"
                    />
                  </div>
                  <div
                    className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity cursor-pointer"
                    onClick={() => {
                      handleOpenModalImageGallery(2);
                      setCurrentIndex(2);
                    }}
                  />
                </div>
              ))}

            <div
              className="absolute flex md:items-center md:justify-center left-3 bottom-3 px-4 py-2 rounded-xl bg-neutral-100 text-neutral-500 cursor-pointer hover:bg-neutral-200 z-10"
              onClick={() => {
                if (bookingDetails?.fleet?.fleet_photos?.length === 0) {
                  toast("No Images available for this fleet", {
                    style: {
                      background: "#fff3cd",
                      color: "#856404",
                    },
                  });
                } else {
                  setIsGridOpen(true);
                }
              }}
            >
              <Squares2X2Icon className="h-5 w-5" />
              <span className="ml-2 text-neutral-800 text-sm font-medium">
                Show all photos
              </span>
            </div>
          </div>
        </header>
        {isOpenModal && (
          <div className="fixed h-full top-0 left-0 w-full  bg-black bg-opacity-90 flex items-center justify-center z-50">
            <button
              className="absolute top-5 right-5 text-white text-xl"
              onClick={closeModal}
            >
              ✖
            </button>

            <div className="w-4/5 ">
              <Slide
                defaultIndex={currentIndex}
                indicators={
                  (bookingDetails?.fleet?.fleet_photos?.length ?? 0) > 1
                }
                arrows={(bookingDetails?.fleet?.fleet_photos?.length ?? 0) > 1}
                autoplay={false}
                duration={2000}
                transitionDuration={300}
                onChange={(current, next) => {
                  setCurrentIndex(next);
                }}
                prevArrow={
                  <button
                    className={`absolute left-4 top-1/2 -translate-y-1/2 z-10 flex items-center justify-center w-10 h-10 rounded-full bg-transparent text-text-color ${
                      (bookingDetails?.fleet?.fleet_photos?.length ?? 0) <= 1 ||
                      currentIndex === 0
                        ? "invisible"
                        : ""
                    }`}
                    type="button"
                    aria-label="Previous"
                  >
                    <span className="default-nav !text-text-color">❮</span>
                  </button>
                }
                nextArrow={
                  <button
                    className={`absolute right-4 top-1/2 -translate-y-1/2 z-10 flex items-center justify-center w-10 h-10 rounded-full bg-transparent text-text-color ${
                      (bookingDetails?.fleet?.fleet_photos?.length ?? 0) <= 1 ||
                      currentIndex ===
                        (bookingDetails?.fleet?.fleet_photos?.length ?? 0) - 1
                        ? "invisible"
                        : ""
                    }`}
                    type="button"
                    aria-label="Next"
                  >
                    <span className="default-nav !text-text-color">❯</span>
                  </button>
                }
              >
                {(bookingDetails?.fleet?.fleet_photos?.length || 0) > 0 ? (
                  bookingDetails?.fleet?.fleet_photos?.map(
                    (item: any, index: number) => (
                      <div
                        className="flex justify-center items-center h-full"
                        key={index}
                      >
                        <img
                          className="w-full max-h-full object-contain rounded-lg"
                          src={
                            item.photo_url.includes("http")
                              ? item.photo_url
                              : `https://fleet-management-images-upload-be.s3.amazonaws.com/${item.photo_url}`
                          }
                          alt={`Slide ${index}`}
                        />
                      </div>
                    ),
                  )
                ) : (
                  <div className="flex justify-center items-center h-full">
                    <img
                      className="w-full max-h-full object-contain rounded-lg"
                      src="https://tenant.fleetwire.io/images/vehicle-placeholder.jpg"
                      alt="No images available"
                    />
                  </div>
                )}
              </Slide>
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderBookingDetailsSection = () => {
    return (
      <>
        <div className="mt-8">
          <div className="grid grid-cols-2 ">
            <div className="col-span-1">
              <span className=" text-lg text-text-color">Pick Up</span>
              <br />
              <span className="mt-1.5 text-lg font-bold text-text-color">
                <span>
                  {formatDateToHumanFirendly(bookingDetails?.pick_up_time)}
                </span>
                <br />
                <span className="font-normal text-text-color">
                  {ourCompany?.default_time_format === "24_hour"
                    ? formatTimeToHumanFirendly24Hour(
                        bookingDetails?.pick_up_time,
                      )
                    : formatTimeToHumanFirendly12Hour(
                        bookingDetails?.pick_up_time,
                      )}
                </span>
              </span>
              <br />
              <span className="mt-1.5 text-lg text-text-color ">
                {bookingDetails?.custom_pick_up_address === ""
                  ? bookingDetails?.pick_up_location?.name
                  : bookingDetails?.custom_pick_up_address}
              </span>
            </div>
            <div className="gap-2">
              <span className=" text-lg text-text-color">Drop Off</span>
              <br />
              <span className="mt-1.5 text-lg font-bold  text-text-color">
                <span>
                  {formatDateToHumanFirendly(bookingDetails?.drop_off_time)}
                </span>
                <br />
                <span className="font-normal text-text-color">
                  {ourCompany?.default_time_format === "24_hour"
                    ? formatTimeToHumanFirendly24Hour(
                        bookingDetails?.drop_off_time,
                      )
                    : formatTimeToHumanFirendly12Hour(
                        bookingDetails?.drop_off_time,
                      )}
                </span>
              </span>
              <br />
              <span className="mt-1.5 text-lg text-text-color">
                {bookingDetails?.custom_drop_off_address === ""
                  ? bookingDetails?.drop_off_location?.name
                  : bookingDetails?.custom_drop_off_address
                    ? bookingDetails?.custom_drop_off_address
                    : bookingDetails?.custom_pick_up_address}
              </span>
            </div>
          </div>
          {bookingDetails?.trip_status !== "cancelled" && (
            <>
              <div className="mt-5 grid grid-cols-1 gap-3 rounded-lg @md:grid-cols-2 @lg:gap-4 @2xl:gap-5">
                <div>
                  <div className="text-lg font-bold text-text-color">
                    Trip Photos
                  </div>
                  <p className="text-text-color">
                    Please take clear photos of the vehicle's exterior,
                    interior, and any existing damages from all angles before
                    starting your trip. Repeat the process upon return to
                    document its condition. This helps protect both parties.
                  </p>
                </div>
                <div className="col-span-full flex flex-col">
                  <div className="flex cursor-pointer flex-row rounded-md border border-secondary-100 p-1">
                    <Button
                      as="span"
                      className={`w-[50%] border-0 text-xl text-text-color leading-[2.2] rounded-md font-semibold sm:h-[45px] flex justify-center ${
                        isPreTrip === true &&
                        "bg-primary-200 !text-button-color"
                      }`}
                      onClick={() => {
                        setIsPreTrip(true);
                      }}
                    >
                      Pre-Trip
                    </Button>
                    <Button
                      as="span"
                      className={`w-[50%] border-0  text-xl text-text-color leading-[2.2] rounded-md font-semibold sm:h-[45px] flex justify-center ${
                        !isPreTrip && "bg-primary-200 !text-button-color"
                      }`}
                      onClick={() => {
                        setIsPreTrip(false);
                      }}
                    >
                      Post-Trip
                    </Button>
                  </div>
                </div>
                {isPreTrip ? (
                  <UploadZone
                    bookingId={bookingDetails?.id}
                    preTrip={isPreTrip}
                  />
                ) : (
                  <UploadZone
                    bookingId={bookingDetails?.id}
                    preTrip={isPreTrip}
                  />
                )}
              </div>
            </>
          )}
          <div className="flex flex-col lg:flex-row lg:justify-between gap-0 md:gap-12">
            <div className="py-8 w-full">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className=" mb-6 md:mb-0">
                  <h2 className="text-lg font-bold mb-8 text-text-color">
                    Trip Info
                  </h2>
                  <div className="mb-4 flex justify-between items-center">
                    <div>
                      <p className="text-text-color ">Total Bill</p>
                      <p className="text-text-color ">
                        {bookingDetails?.final_price_without_security}
                      </p>
                    </div>

                    <div
                      onClick={handleOpenTotalBillModal}
                      className="text-text-color cursor-pointer mx-2"
                    >
                      <div className="flex text-text-color font-semibold">
                        View Invoice
                        <svg
                          width="23"
                          height="26"
                          viewBox="0 0 23 26"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.5253 19.7222C13.3481 19.7222 13.1709 19.6488 13.031 19.4917C12.7605 19.1879 12.7605 18.685 13.031 18.3812L18.1977 12.5774L13.031 6.77361C12.7605 6.4698 12.7605 5.96694 13.031 5.66313C13.3014 5.35932 13.7491 5.35932 14.0195 5.66313L19.6806 12.0222C19.951 12.326 19.951 12.8288 19.6806 13.1327L14.0195 19.4917C13.8797 19.6488 13.7025 19.7222 13.5253 19.7222Z"
                            fill="#90A3BF"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="mb-4 flex justify-between items-center">
                    <div>
                      <p className="text-text-color">Agreement</p>
                    </div>
                    <div
                      onClick={openRentalAgreement}
                      className="text-text-color cursor-pointer mx-2"
                    >
                      <div className="flex text-text-color font-semibold">
                        View Agreement
                        <svg
                          width="23"
                          height="26"
                          viewBox="0 0 23 26"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.5253 19.7222C13.3481 19.7222 13.1709 19.6488 13.031 19.4917C12.7605 19.1879 12.7605 18.685 13.031 18.3812L18.1977 12.5774L13.031 6.77361C12.7605 6.4698 12.7605 5.96694 13.031 5.66313C13.3014 5.35932 13.7491 5.35932 14.0195 5.66313L19.6806 12.0222C19.951 12.326 19.951 12.8288 19.6806 13.1327L14.0195 19.4917C13.8797 19.6488 13.7025 19.7222 13.5253 19.7222Z"
                            fill="#90A3BF"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>

                  <div className="mb-4 flex justify-between items-center">
                    <div>
                      <p className="text-text-color ">Get Booking Email</p>
                    </div>
                    <span
                      className="text-text-color mx-2 cursor-pointer font-semibold"
                      onClick={() => sendAgreementEmail("booking_confirmation")}
                    >
                      Resend email
                    </span>
                  </div>
                  <div className="mb-4 flex justify-between items-center">
                    <div>
                      <p className="text-text-color ">Get Agreement</p>
                    </div>
                    <span
                      className="text-text-color mx-2 cursor-pointer font-semibold"
                      onClick={() => sendAgreementEmail("rental_agreement")}
                    >
                      Resend email
                    </span>
                  </div>

                  {bookingDetails?.bonzah_purchase_response_data?.data?.coverage_information
                    ?.filter((insurance: any) => insurance?.added === true)
                    ?.map((insurance: any, index: any) => (
                      <div
                        key={index}
                        onClick={async () => {
                          try {
                            const { data, error }: any = await getBonzahPDF(
                              bookingDetails?.id,
                              extractSubstringInBrackets(
                                insurance?.optional_addon_cover_name?.toLowerCase() ??
                                  "",
                              ) ?? "",
                            );

                            if (error) {
                              throw new Error(error);
                            }
                            if (data instanceof ArrayBuffer) {
                              const pdfBlob = new Blob([data], {
                                type: "application/pdf",
                              });

                              const pdfUrl = URL.createObjectURL(pdfBlob);
                              const newTab = window.open(pdfUrl, "_blank");

                              if (newTab) {
                                newTab.focus();
                              } else {
                                const pdfUrl = URL.createObjectURL(pdfBlob);
                                const link = document.createElement("a");
                                link.href = pdfUrl;
                                link.target = "_blank";
                                link.download = "insurance_agreement.pdf";
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                              }
                            } else {
                              throw new Error("Invalid PDF data received.");
                            }
                          } catch (error: any) {
                            console.error("Error fetching PDF:", error);
                            toast.error(
                              error.message ||
                                "An error occurred while fetching the PDF.",
                            );
                          }
                        }}
                        className="w-full cursor-pointer justify-between overflow-clip rounded-md"
                      >
                        <div className="mt-3 flex items-center justify-between">
                          <div>
                            <div className="text-text-color ">
                              Insurance Agreement:{" "}
                              {insurance?.optional_addon_cover_name}
                            </div>
                            <div className="text-xs font-medium text-text-color">
                              {insurance?.policy_created_date}
                            </div>
                          </div>
                          <div className="min-h-5 min-w-5 font-bold">
                            <svg
                              width="23"
                              height="26"
                              viewBox="0 0 23 26"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M13.5253 19.7222C13.3481 19.7222 13.1709 19.6488 13.031 19.4917C12.7605 19.1879 12.7605 18.685 13.031 18.3812L18.1977 12.5774L13.031 6.77361C12.7605 6.4698 12.7605 5.96694 13.031 5.66313C13.3014 5.35932 13.7491 5.35932 14.0195 5.66313L19.6806 12.0222C19.951 12.326 19.951 12.8288 19.6806 13.1327L14.0195 19.4917C13.8797 19.6488 13.7025 19.7222 13.5253 19.7222Z"
                                fill="#90A3BF"
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
                <div className="mb-6 md:mb-0">
                  <div className="flex justify-between items-center mb-8">
                    <h2 className="text-lg font-bold text-text-color">
                      Renter Info
                    </h2>
                    {bookingDetails?.trip_status !== "cancelled" &&
                      bookingDetails?.cancellation_pending !== true && (
                        <p
                          className="text-lg text-text-color cursor-pointer"
                          onClick={() => setIsRenterInfoEdit(!isRenterInfoEdit)}
                        >
                          {isRenterInfoEdit ? "Cancel" : "Edit"}
                        </p>
                      )}
                  </div>
                  {!isRenterInfoEdit ? (
                    <>
                      <div className="mb-4 flex ">
                        <div>
                          <p className="text-text-color ">
                            {bookingDetails?.customer?.first_name}{" "}
                            {bookingDetails?.customer?.last_name}
                          </p>
                        </div>
                      </div>
                      <div className="mb-4 flex">
                        <div>
                          <p className="text-text-color ">
                            {bookingDetails?.customer?.email}
                          </p>
                        </div>
                      </div>
                      <div className="mb-4 flex ">
                        <div>
                          <p className="text-text-color ">
                            <PhoneNumberDisplay
                              phone={bookingDetails?.customer?.phone_no}
                            />
                          </p>
                        </div>
                      </div>
                    </>
                  ) : (
                    <RenterInfo
                      bookingDetails={bookingDetails}
                      setIsRenterInfoEdit={setIsRenterInfoEdit}
                      onSuccessfulUpdate={fetchBookingDetail}
                    />
                  )}
                  {identityLink ? (
                    <div className="mb-4 flex justify-between items-center">
                      <div>
                        <p className="text-text-color  truncate max-w-48">
                          {identityLink}
                        </p>
                      </div>
                      <span
                        className={`mx-2 cursor-pointer font-semibold text-red-600`}
                        onClick={() => {
                          navigator.clipboard.writeText(identityLink);
                          toast.success("Link Copied");
                        }}
                      >
                        Copy
                      </span>
                    </div>
                  ) : (
                    <div className="mb-4 flex justify-between items-center">
                      <div>
                        <p className="text-text-color">ID Verification</p>
                      </div>
                      <span
                        className={`mx-2 cursor-pointer font-semibold ${
                          bookingDetails?.customer?.identity_verified
                            ? "text-green-600"
                            : "text-red-600"
                        }`}
                        {...(!bookingDetails?.customer?.identity_verified && {
                          onClick: handlePrimaryDriverVerificationButtonClick,
                        })}
                      >
                        <div className="flex">
                          {bookingDetails &&
                          bookingDetails?.customer?.identity_verified !== true
                            ? "Create Verification Link"
                            : "Verified"}
                          {bookingDetails?.customer?.identity_verified !==
                            true && (
                            <svg
                              width="23"
                              height="26"
                              viewBox="0 0 23 26"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M13.5253 19.7222C13.3481 19.7222 13.1709 19.6488 13.031 19.4917C12.7605 19.1879 12.7605 18.685 13.031 18.3812L18.1977 12.5774L13.031 6.77361C12.7605 6.4698 12.7605 5.96694 13.031 5.66313C13.3014 5.35932 13.7491 5.35932 14.0195 5.66313L19.6806 12.0222C19.951 12.326 19.951 12.8288 19.6806 13.1327L14.0195 19.4917C13.8797 19.6488 13.7025 19.7222 13.5253 19.7222Z"
                                fill="#90A3BF"
                              />
                            </svg>
                          )}
                        </div>
                      </span>
                    </div>
                  )}

                  {canopyLink ? (
                    <div className="mb-4 flex justify-between items-center">
                      <div>
                        <p className="text-text-color truncate max-w-48">
                          {canopyLink}
                        </p>
                      </div>
                      <span
                        className={`mx-2 cursor-pointer font-semibold text-red-600`}
                        onClick={() => {
                          navigator.clipboard.writeText(canopyLink);
                          toast.success("Link Copied");
                        }}
                      >
                        Copy
                      </span>
                    </div>
                  ) : (
                    <div className="mb-4 flex justify-between items-center">
                      <div>
                        <p className="text-text-color">
                          Insurance Verification
                        </p>
                      </div>
                      <span
                        className={`mx-2 cursor-pointer font-semibold ${
                          bookingDetails?.customer?.insurance_verified
                            ? "text-green-600"
                            : "text-red-600"
                        }`}
                        {...(!bookingDetails?.customer?.insurance_verified && {
                          onClick: handleCanopyVerificationButtonClick,
                        })}
                      >
                        <div className="flex">
                          {bookingDetails &&
                          bookingDetails?.customer?.insurance_verified !== true
                            ? "Create Verification Link"
                            : "Verified"}
                          {bookingDetails?.customer?.insurance_verified !==
                            true && (
                            <svg
                              width="23"
                              height="26"
                              viewBox="0 0 23 26"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M13.5253 19.7222C13.3481 19.7222 13.1709 19.6488 13.031 19.4917C12.7605 19.1879 12.7605 18.685 13.031 18.3812L18.1977 12.5774L13.031 6.77361C12.7605 6.4698 12.7605 5.96694 13.031 5.66313C13.3014 5.35932 13.7491 5.35932 14.0195 5.66313L19.6806 12.0222C19.951 12.326 19.951 12.8288 19.6806 13.1327L14.0195 19.4917C13.8797 19.6488 13.7025 19.7222 13.5253 19.7222Z"
                                fill="#90A3BF"
                              />
                            </svg>
                          )}
                        </div>
                      </span>
                    </div>
                  )}

                  {bookingDetails?.secondary_driver_obj && (
                    <>
                      {driveridentityLink ? (
                        <div className="mb-4 flex justify-between items-center">
                          <div>
                            <p className="text-gray-800 dark:text-white truncate max-w-48">
                              {driveridentityLink}
                            </p>
                          </div>
                          <span
                            className={`mx-2 cursor-pointer font-semibold text-red-600`}
                            onClick={() => {
                              navigator.clipboard.writeText(driveridentityLink);
                              toast.success("Link Copied");
                            }}
                          >
                            Copy
                          </span>
                        </div>
                      ) : (
                        <div className="mb-4 flex justify-between items-center">
                          <div>
                            <p className="text-gray-800 dark:text-white">
                              Secondary Driver ID Verification
                            </p>
                          </div>
                          <span
                            className={`mx-2 cursor-pointer font-semibold ${
                              bookingDetails.secondary_driver_obj
                                .identity_verified
                                ? "text-green-600"
                                : "text-red-600"
                            }`}
                            {...(!bookingDetails.secondary_driver_obj
                              .identity_verified && {
                              onClick:
                                handleDriverPrimaryDriverVerificationButtonClick,
                            })}
                          >
                            <div className="flex">
                              {bookingDetails.secondary_driver_obj
                                .identity_verified
                                ? "Verified"
                                : "Create Verification Link"}
                              {!bookingDetails.secondary_driver_obj
                                .identity_verified && (
                                <svg
                                  width="23"
                                  height="26"
                                  viewBox="0 0 23 26"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M13.5253 19.7222C13.3481 19.7222 13.1709 19.6488 13.031 19.4917C12.7605 19.1879 12.7605 18.685 13.031 18.3812L18.1977 12.5774L13.031 6.77361C12.7605 6.4698 12.7605 5.96694 13.031 5.66313C13.3014 5.35932 13.7491 5.35932 14.0195 5.66313L19.6806 12.0222C19.951 12.326 19.951 12.8288 19.6806 13.1327L14.0195 19.4917C13.8797 19.6488 13.7025 19.7222 13.5253 19.7222Z"
                                    fill="#90A3BF"
                                  />
                                </svg>
                              )}
                            </div>
                          </span>
                        </div>
                      )}

                      {drivercanopyLink ? (
                        <div className="mb-4 flex justify-between items-center">
                          <div>
                            <p className="text-gray-800 dark:text-white truncate max-w-48">
                              {drivercanopyLink}
                            </p>
                          </div>
                          <span
                            className={`mx-2 cursor-pointer font-semibold text-red-600`}
                            onClick={() => {
                              navigator.clipboard.writeText(drivercanopyLink);
                              toast.success("Link Copied");
                            }}
                          >
                            Copy
                          </span>
                        </div>
                      ) : (
                        <div className="mb-4 flex justify-between items-center">
                          <div>
                            <p className="text-gray-800 dark:text-white">
                              Secondary Driver Insurance Verification
                            </p>
                          </div>
                          <span
                            className={`mx-2 cursor-pointer font-semibold ${
                              bookingDetails.secondary_driver_obj
                                .insurance_verified
                                ? "text-green-600"
                                : "text-red-600"
                            }`}
                            {...(!bookingDetails.secondary_driver_obj
                              .insurance_verified && {
                              onClick:
                                handleDriverCanopyVerificationButtonClick,
                            })}
                          >
                            <div className="flex">
                              {bookingDetails.secondary_driver_obj
                                .insurance_verified
                                ? "Verified"
                                : "Create Verification Link"}
                              {!bookingDetails.secondary_driver_obj
                                .insurance_verified && (
                                <svg
                                  width="23"
                                  height="26"
                                  viewBox="0 0 23 26"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M13.5253 19.7222C13.3481 19.7222 13.1709 19.6488 13.031 19.4917C12.7605 19.1879 12.7605 18.685 13.031 18.3812L18.1977 12.5774L13.031 6.77361C12.7605 6.4698 12.7605 5.96694 13.031 5.66313C13.3014 5.35932 13.7491 5.35932 14.0195 5.66313L19.6806 12.0222C19.951 12.326 19.951 12.8288 19.6806 13.1327L14.0195 19.4917C13.8797 19.6488 13.7025 19.7222 13.5253 19.7222Z"
                                    fill="#90A3BF"
                                  />
                                </svg>
                              )}
                            </div>
                          </span>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
              <div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  <div className="w-full mt-4">
                    <h2 className="text-lg font-bold my-4 text-text-color">
                      About The Car
                    </h2>
                    <div className="mb-4">
                      <p className="text-text-color truncater">
                        {bookingDetails?.fleet?.name}
                      </p>
                    </div>
                    <div className="mb-4 flex justify-between">
                      <p className="text-text-color">License plate number</p>
                      <span className="font-bold text-text-color">
                        {bookingDetails?.fleet?.plate_number}
                      </span>
                    </div>
                    <div className="mb-4 flex justify-between">
                      <p className="text-text-color">Car color</p>
                      <span className="font-bold text-text-color">
                        {bookingDetails?.fleet?.color}
                      </span>
                    </div>
                    <div className="mb-4 flex justify-between">
                      <span className="text-text-color">Build</span>
                      <span className="font-bold text-text-color truncate w-44 text-right">
                        {bookingDetails?.fleet?.make}
                      </span>
                    </div>
                  </div>
                </div>
                {bookingDetails?.note === null ||
                bookingDetails?.note === "" ? (
                  ""
                ) : (
                  <div className="w-full mt-12">
                    <h2 className="text-xl font-bold mb-8 text-text-color">
                      Note
                    </h2>
                    <span className="text-text-color whitespace-pre-wrap break-words">
                      {bookingDetails?.note
                        .split(/(\s+)/)
                        .map((part: string, index: number) => {
                          const urlRegex = /^(https?:\/\/[^\s]+)$/;
                          if (urlRegex.test(part.trim())) {
                            return (
                              <a
                                key={index}
                                href={part.trim()}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-600 hover:underline"
                              >
                                {part.trim()}
                              </a>
                            );
                          }
                          return part;
                        })}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>

          {bookingDetails?.is_long_term_rental && (
            <div className="mt-8">
              <ConnectedBookings bookingDetails={bookingDetails ?? []} />
            </div>
          )}
          <div className="mt-12">
            <PreviousBookings
              booking_id={bookingId ?? ""}
              cancellationPolicy={cancellationPolicy}
              privacyPolicy={privacyPolicy}
            />
          </div>
        </div>
      </>
    );
  };

  const renderCarDetailsSection = () => {
    return (
      <div>
        <div className="grid grid-cols-2 gap-y-8 gap-x-6 md:grid-cols-5">
          <div className="flex flex-col">
            <span className="text-md font-medium text-text-color my-2">
              Booking Status
            </span>
            <Badge
              className="items-center py-2 max-w-fit px-6"
              color={
                bookingDetails?.trip_status === "pending"
                  ? "yellow"
                  : bookingDetails?.trip_status === "cancelled"
                    ? "red"
                    : "green"
              }
              name={
                bookingDetails?.trip_status
                  ? bookingDetails.trip_status.charAt(0).toUpperCase() +
                    bookingDetails.trip_status.slice(1)
                  : ""
              }
            />
          </div>
          <div className="flex flex-col ">
            <span className="text-md font-medium text-text-color my-2">
              Booking ID
            </span>
            <span className="text-base font-semibold text-text-color">
              # {bookingDetails?.id}
            </span>
          </div>
          <div className="flex flex-col ">
            <span className="text-md font-medium text-text-color my-2">
              Vehicle Name
            </span>
            <span className="text-base font-semibold text-text-color truncate">
              {bookingDetails?.fleet?.name}
            </span>
          </div>
          <div className="flex flex-col ">
            <span className="text-md font-medium text-text-color my-2">
              Renter Name
            </span>
            <span className="text-base font-semibold text-text-color">
              {bookingDetails?.customer?.first_name}{" "}
              {bookingDetails?.customer?.last_name}
            </span>
          </div>
          {bookingDetails.drop_off_time &&
            bookingDetails.trip_status !== "cancelled" &&
            bookingDetails?.cancellation_pending !== true &&
            new Date(bookingDetails?.drop_off_time).getTime() +
              24 * 60 * 60 * 1000 >
              Date.now() && (
              <div className="col-span-2 md:col-span-1 gap-2 flex items-center justify-center">
                {bookingDetails.trip_status !== "completed" && (
                  <button
                    className="w-full md:w-auto p-2 text-sm font-medium  border border-[#263238] min-w-32 ttnc-ButtonPrimary !rounded-md disabled:bg-opacity-70 bg-primary-6000 hover:bg-primary-700 text-button-color hover:ring-primary-6000 hover:ring-offset-2 hover:ring-2"
                    onClick={() => {
                      setIsCancelModalOpen(true);
                    }}
                  >
                    Cancel Booking
                  </button>
                )}

                <button
                  className="w-full md:w-auto p-2 text-sm font-medium  border border-[#263238] min-w-32 ttnc-ButtonPrimary !rounded-md disabled:bg-opacity-70 bg-primary-6000 hover:bg-primary-700 text-button-color hover:ring-primary-6000 hover:ring-offset-2 hover:ring-2"
                  onClick={() => {
                    setIsEdit(!isEdit);
                  }}
                >
                  {isEdit ? "Cancel Changes" : "Edit Booking"}
                </button>
              </div>
            )}
        </div>
      </div>
    );
  };

  const renderCancelBookingSection = () => {
    return (
      <div className="py-8 w-full">
        <h2 className="text-lg font-bold mb-8 text-text-color">Trip Info</h2>
        <div className="mb-4 flex justify-between items-center">
          <div>
            <p className="text-text-color">Total Bill</p>
            <p className="text-text-color">
              {bookingDetails?.invoice
                ?.total_price_after_coupon_without_security !== null
                ? bookingDetails?.invoice
                    ?.total_price_after_coupon_without_security
                : "$" + bookingDetails?.invoice?.total_price_without_security}
            </p>
          </div>

          <div
            onClick={handleOpenTotalBillModal}
            className="text-text-color cursor-pointer mx-2"
          >
            <div className="flex text-text-color font-semibold">
              Cost Summary
              <svg
                width="23"
                height="26"
                viewBox="0 0 23 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.5253 19.7222C13.3481 19.7222 13.1709 19.6488 13.031 19.4917C12.7605 19.1879 12.7605 18.685 13.031 18.3812L18.1977 12.5774L13.031 6.77361C12.7605 6.4698 12.7605 5.96694 13.031 5.66313C13.3014 5.35932 13.7491 5.35932 14.0195 5.66313L19.6806 12.0222C19.951 12.326 19.951 12.8288 19.6806 13.1327L14.0195 19.4917C13.8797 19.6488 13.7025 19.7222 13.5253 19.7222Z"
                  fill="#90A3BF"
                />
              </svg>
            </div>
          </div>
        </div>

        <div className="mb-4 flex justify-between items-center">
          <div>
            <p className="text-text-color">Agreement</p>
          </div>
          <div
            onClick={openRentalAgreement}
            className="text-text-color cursor-pointer mx-2"
          >
            <div className="flex text-text-color font-semibold">
              View Agreement
              <svg
                width="23"
                height="26"
                viewBox="0 0 23 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.5253 19.7222C13.3481 19.7222 13.1709 19.6488 13.031 19.4917C12.7605 19.1879 12.7605 18.685 13.031 18.3812L18.1977 12.5774L13.031 6.77361C12.7605 6.4698 12.7605 5.96694 13.031 5.66313C13.3014 5.35932 13.7491 5.35932 14.0195 5.66313L19.6806 12.0222C19.951 12.326 19.951 12.8288 19.6806 13.1327L14.0195 19.4917C13.8797 19.6488 13.7025 19.7222 13.5253 19.7222Z"
                  fill="#90A3BF"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderContent = () => {
    return (
      <div className="w-full flex flex-col space-y-8 ">
        {renderImgSection()}
        {renderCarDetailsSection()}

        <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
      </div>
    );
  };

  const rendernoBooking = () => {
    return (
      <div className="min-h-[60vh]">
        <p>Booking Not Found</p>
      </div>
    );
  };
  return (
    <>
      {bookingloading ? (
        <div className="flex justify-center items-center col-span-full py-96">
          <div className="spinner-border animate-spin inline-block w-6 h-6 border-4 rounded-full border-t-transparent border-gray-300"></div>
        </div>
      ) : (
        <div className={`nc-PayPage ${className}`} data-nc-id="PayPage">
          {bookingDetails?.cancellation_pending === true && (
            <div className="min-h-22 flex items-center container mt-4">
              <div className="flex bg-yellow-100 border border-yellow-300 flex-row w-full items-center max-w-6xl mx-auto p-2 sm:p-4 rounded-md sm:rounded-xl">
                <ExclamationTriangleIcon className="w-6 h-6 sm:w-8 sm:h-8 text-yellow-600 flex-shrink-0 mr-3 sm:mr-4" />
                <div className="flex-1">
                  <p className="text-yellow-900 font-bold text-sm sm:text-lg leading-tight">
                    Cancellation Request Pending
                  </p>
                  <p className="text-yellow-800 text-xs sm:text-sm mt-1">
                    Your cancellation request is being reviewed by our team.
                    You'll be notified once it's processed.
                  </p>
                </div>
              </div>
            </div>
          )}
          {bookingDetails?.modification_pending === true && (
            <div className="min-h-22 flex items-center container mt-4">
              <div className="flex bg-yellow-100 border border-yellow-300 flex-row w-full items-center max-w-6xl mx-auto p-2 sm:p-4 rounded-md sm:rounded-xl">
                <ExclamationTriangleIcon className="w-6 h-6 sm:w-8 sm:h-8 text-yellow-600 flex-shrink-0 mr-3 sm:mr-4" />
                <div className="flex-1">
                  <p className="text-yellow-900 font-bold text-sm sm:text-lg leading-tight">
                    Modification Request Pending
                  </p>
                  <p className="text-yellow-800 text-xs sm:text-sm mt-1">
                    Your modification request is being reviewed by our team.
                    You'll be notified once it's approved or if any changes are
                    needed.
                  </p>
                </div>
              </div>
            </div>
          )}
          {!identityLink &&
            bookingDetails &&
            bookingDetails?.customer?.identity_verified !== true && (
              <>
                <div className="min-h-22 flex items-center container mt-4">
                  <div className="flex bg-[#FF757587] flex-row w-full items-center justify-between max-w-6xl mx-auto p-2 sm:p-4 rounded-md sm:rounded-xl">
                    <span className="text-[#FF0000] font-medium text-[10px] md:text-2xl leading-tight">
                      Verify your{" "}
                      <span className="font-extrabold">identity</span> to
                      confirm your booking
                    </span>
                    <ButtonPrimary
                      onClick={handlePrimaryDriverVerificationButtonClick}
                      className="!bg-[#FF0000] min-w-16 max-w-20 sm:max-w-none !hover:bg-[#FF0000] text-white !text-[10px] sm:!text-[16px] font-bold md:py-2 px-2 rounded-xl whitespace-nowrap h-[34px] md:h-[48px]"
                    >
                      {identityLoading ? (
                        <div className="flex justify-center items-center col-span-full">
                          <div className="spinner-border animate-spin inline-block w-6 h-6 border-4 rounded-full border-t-transparent border-gray-300"></div>
                        </div>
                      ) : (
                        <>
                          <span className="block sm:hidden">Create Link</span>
                          <span className="hidden sm:block">
                            Create Verification Link
                          </span>
                        </>
                      )}
                    </ButtonPrimary>
                  </div>
                </div>
              </>
            )}
          {identityLink && (
            <div className="min-h-22 flex items-center container mt-4">
              <div className="flex bg-[#FF757587] flex-row w-full items-center justify-between max-w-6xl mx-auto p-2 sm:p-4 rounded-md sm:rounded-xl">
                <span className="text-white font-medium text-[14px] md:text-2xl break-words truncate">
                  {identityLink}
                </span>
                <div className="space-x-4 flex-col md:flex-row space-y-4">
                  {/* <button className="ttnc-ButtonPrimary disabled:bg-opacity-70 bg-none border text-sm border-[#FF0000] text-[#FF0000] font-bold py-3 px-4 sm:px-6 rounded-xl">
                    Purchase Insurance
                  </button> */}
                  <ButtonPrimary
                    onClick={() => {
                      navigator.clipboard.writeText(identityLink);
                      toast.success("Link Copied");
                    }}
                    className="!bg-[#FF0000] min-w-20 ml-2 !hover:bg-[#FF0000] text-white text-[12px] font-bold rounded-xl px-4 py-3 whitespace-nowrap"
                  >
                    Copy
                  </ButtonPrimary>
                  <ButtonPrimary
                    onClick={() => window.open(identityLink, "_blank")}
                    className="!bg-[#FF0000] min-w-20 ml-2 !hover:bg-[#FF0000] text-white text-[12px] font-bold rounded-xl px-4 py-3 whitespace-nowrap"
                  >
                    Open
                  </ButtonPrimary>
                </div>
              </div>
            </div>
          )}
          {bookingDetails?.trip_status !== "cancelled" &&
            bookingDetails?.cancellation_pending !== true &&
            !canopyLink &&
            bookingDetails &&
            bookingDetails?.customer?.insurance_verified !== true && (
              <div className="min-h-22 flex items-center container mt-4">
                <div className="flex bg-[#FF757587] flex-row w-full items-center justify-between max-w-6xl mx-auto p-2 sm:p-4 rounded-md sm:rounded-xl">
                  <span className="text-[#FF0000] font-medium text-[10px] md:text-2xl leading-tight">
                    Verify your{" "}
                    <span className="font-extrabold">insurance</span> to confirm
                    your booking
                  </span>
                  <div className="space-x-4 flex-col md:flex-row space-y-4">
                    <ButtonPrimary
                      onClick={handleCanopyVerificationButtonClick}
                      className="!bg-[#FF0000] min-w-16 max-w-20 sm:max-w-none !hover:bg-[#FF0000] text-white !text-[10px] sm:!text-[16px] font-bold md:py-2 px-2 rounded-xl whitespace-nowrap h-[34px] md:h-[48px]"
                    >
                      {canopyLoading ? (
                        <div className="flex justify-center items-center col-span-full">
                          <div className="spinner-border animate-spin inline-block w-6 h-6 border-4 rounded-full border-t-transparent border-gray-300"></div>
                        </div>
                      ) : (
                        <>
                          <span className="block sm:hidden">Create Link</span>
                          <span className="hidden sm:block">
                            Create Verification Link
                          </span>
                        </>
                      )}
                    </ButtonPrimary>
                  </div>
                </div>
              </div>
            )}
          {canopyLink && (
            <div className="min-h-22 flex items-center container mt-4">
              <div className="flex bg-[#FF757587] flex-row w-full items-center justify-between max-w-6xl mx-auto p-2 sm:p-4 rounded-md sm:rounded-xl">
                <span className="text-white font-medium text-[14px] md:text-2xl break-words truncate">
                  {canopyLink}
                </span>
                <div className="space-x-4 flex-col md:flex-row space-y-4">
                  {/* <button className="ttnc-ButtonPrimary disabled:bg-opacity-70 bg-none border text-sm border-[#FF0000] text-[#FF0000] font-bold py-3 px-4 sm:px-6 rounded-xl">
                    Purchase Insurance
                  </button> */}
                  <ButtonPrimary
                    onClick={() => {
                      navigator.clipboard.writeText(canopyLink);
                      toast.success("Link Copied");
                    }}
                    className="!bg-[#FF0000] min-w-20 ml-2 !hover:bg-[#FF0000] text-white text-[12px] font-bold rounded-xl px-4 py-3 whitespace-nowrap"
                  >
                    Copy
                  </ButtonPrimary>
                  <ButtonPrimary
                    onClick={() => window.open(canopyLink, "_blank")}
                    className="!bg-[#FF0000] min-w-20 ml-2 !hover:bg-[#FF0000] text-white text-[12px] font-bold rounded-xl px-4 py-3 whitespace-nowrap"
                  >
                    Open
                  </ButtonPrimary>
                </div>
              </div>
            </div>
          )}
          {!driveridentityLink &&
            bookingDetails?.trip_status !== "cancelled" &&
            bookingDetails?.cancellation_pending !== true &&
            bookingDetails &&
            bookingDetails?.secondary_driver_obj?.identity_verified !== null &&
            bookingDetails?.secondary_driver_obj?.identity_verified ===
              false && (
              <>
                <div className="min-h-22 flex items-center container mt-4">
                  <div className="flex bg-[#FF757587] flex-row w-full items-center justify-between max-w-6xl mx-auto p-2 sm:p-4 rounded-md sm:rounded-xl">
                    <span className="text-[#FF0000] font-medium text-[10px] md:text-2xl leading-tight">
                      Verify your{" "}
                      <span className="font-extrabold">
                        {" "}
                        secondary driver identity
                      </span>{" "}
                      to confirm your booking
                    </span>
                    <ButtonPrimary
                      onClick={handleDriverPrimaryDriverVerificationButtonClick}
                      className="!bg-[#FF0000] min-w-16 max-w-20 sm:max-w-none !hover:bg-[#FF0000] text-white !text-[10px] sm:!text-[16px] font-bold md:py-2 px-2 rounded-xl whitespace-nowrap h-[34px] md:h-[48px]"
                    >
                      {driveridentityLoading ? (
                        <div className="flex justify-center items-center col-span-full">
                          <div className="spinner-border animate-spin inline-block w-6 h-6 border-4 rounded-full border-t-transparent border-gray-300"></div>
                        </div>
                      ) : (
                        <>
                          <span className="block sm:hidden">Create Link</span>
                          <span className="hidden sm:block">
                            Create Verification Link
                          </span>
                        </>
                      )}
                    </ButtonPrimary>
                  </div>
                </div>
              </>
            )}
          {driveridentityLink && (
            <div className="min-h-22 flex items-center container mt-4">
              <div className="flex bg-[#FF757587] flex-row w-full items-center justify-between max-w-6xl mx-auto p-2 sm:p-4 rounded-md sm:rounded-xl">
                <span className="text-white font-medium text-[14px] md:text-2xl break-words truncate">
                  {driveridentityLink}
                </span>
                <div className="space-x-4 flex-col md:flex-row space-y-4">
                  {/* <button className="ttnc-ButtonPrimary disabled:bg-opacity-70 bg-none border text-sm border-[#FF0000] text-[#FF0000] font-bold py-3 px-4 sm:px-6 rounded-xl">
                    Purchase Insurance
                  </button> */}
                  <ButtonPrimary
                    onClick={() => {
                      navigator.clipboard.writeText(driveridentityLink);
                      toast.success("Link Copied");
                    }}
                    className="!bg-[#FF0000] min-w-20 ml-2 !hover:bg-[#FF0000] text-white text-[12px] font-bold rounded-xl px-4 py-3 whitespace-nowrap"
                  >
                    Copy
                  </ButtonPrimary>
                  <ButtonPrimary
                    onClick={() => window.open(driveridentityLink, "_blank")}
                    className="!bg-[#FF0000] min-w-20 ml-2 !hover:bg-[#FF0000] text-white text-[12px] font-bold rounded-xl px-4 py-3 whitespace-nowrap"
                  >
                    Open
                  </ButtonPrimary>
                </div>
              </div>
            </div>
          )}
          {!drivercanopyLink &&
            bookingDetails?.trip_status !== "cancelled" &&
            bookingDetails?.cancellation_pending !== true &&
            bookingDetails &&
            bookingDetails?.secondary_driver_obj !== null &&
            bookingDetails?.secondary_driver_obj?.insurance_verified ===
              false && (
              <div className="min-h-22 flex items-center container mt-4">
                <div className="flex bg-[#FF757587] flex-row w-full items-center justify-between max-w-6xl mx-auto p-2 sm:p-4 rounded-md sm:rounded-xl">
                  <span className="text-[#FF0000] font-medium text-[10px] md:text-2xl leading-tight">
                    Verify your{" "}
                    <span className="font-extrabold">
                      secondary driver insurance
                    </span>{" "}
                    to confirm your booking
                  </span>
                  <div className="space-x-4 flex-col md:flex-row space-y-4">
                    <ButtonPrimary
                      onClick={handleDriverCanopyVerificationButtonClick}
                      className="!bg-[#FF0000] min-w-16 max-w-20 sm:max-w-none !hover:bg-[#FF0000] text-white !text-[10px] sm:!text-[16px] font-bold md:py-2 px-2 rounded-xl whitespace-nowrap h-[34px] md:h-[48px]"
                    >
                      {drivercanopyLoading ? (
                        <div className="flex justify-center items-center col-span-full">
                          <div className="spinner-border animate-spin inline-block w-6 h-6 border-4 rounded-full border-t-transparent border-gray-300"></div>
                        </div>
                      ) : (
                        <>
                          <span className="block sm:hidden">Create Link</span>
                          <span className="hidden sm:block">
                            Create Verification Link
                          </span>
                        </>
                      )}
                    </ButtonPrimary>
                  </div>
                </div>
              </div>
            )}
          {drivercanopyLink && (
            <div className="min-h-22 flex items-center container mt-4">
              <div className="flex bg-[#FF757587] flex-row w-full items-center justify-between max-w-6xl mx-auto p-2 sm:p-4 rounded-md sm:rounded-xl">
                <span className="text-white font-medium text-[14px] md:text-2xl break-words truncate">
                  {drivercanopyLink}
                </span>
                <div className="flex flex-row gap-2">
                  <ButtonPrimary
                    onClick={() => {
                      navigator.clipboard.writeText(drivercanopyLink);
                      toast.success("Link Copied");
                    }}
                    className="!bg-[#FF0000] min-w-20 ml-2 !hover:bg-[#FF0000] text-white text-[12px] font-bold rounded-xl px-4 py-3 whitespace-nowrap"
                  >
                    Copy
                  </ButtonPrimary>
                  <ButtonPrimary
                    onClick={() => window.open(drivercanopyLink, "_blank")}
                    className="!bg-[#FF0000] min-w-20 ml-2 !hover:bg-[#FF0000] text-white text-[12px] font-bold rounded-xl px-4 py-3 whitespace-nowrap"
                  >
                    Open
                  </ButtonPrimary>
                </div>
              </div>
            </div>
          )}
          <Transition appear show={isOpen}>
            <Dialog
              as="div"
              className="relative z-10 focus:outline-none border"
              onClose={close}
            >
              <div className="fixed inset-0 z-10 w-screen overflow-y-auto border border-primary-6000">
                <div className="flex min-h-full items-center justify-center p-4">
                  <TransitionChild
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 transform-[scale(95%)]"
                    enterTo="opacity-100 transform-[scale(100%)]"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 transform-[scale(100%)]"
                    leaveTo="opacity-0 transform-[scale(95%)]"
                  >
                    <DialogPanel className="w-full max-w-md bg-white rounded-x p-6 backdrop-blur-2xl rounded-md  border border-primary-6000">
                      <div className="flex justify-between mb-6">
                        <DialogTitle as="h3" className="font-medium text-xl">
                          Modify Trip
                        </DialogTitle>
                        <button onClick={close}>
                          <XMarkIcon className="h-6 w-6" />
                        </button>
                      </div>

                      <ButtonPrimary
                        className="bg-primary-500 w-full mb-5"
                        onClick={() => {
                          modifyBooking(bookingId!);
                        }}
                      >
                        Modify Booking
                      </ButtonPrimary>
                    </DialogPanel>
                  </TransitionChild>
                </div>
              </div>
            </Dialog>
          </Transition>
          <Transition appear show={isTotalBillModalOpen}>
            <Dialog as="div" className="relative z-50" onClose={() => {}}>
              <div className="fixed inset-0 z-50 w-screen overflow-y-auto">
                <div className="flex min-h-full items-center justify-center p-4">
                  <TransitionChild
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 transform scale-95"
                    enterTo="opacity-100 transform scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 transform scale-100"
                    leaveTo="opacity-0 transform scale-95"
                  >
                    <DialogPanel className="w-full max-w-md bg-bg-color border border-secondary-100 p-6 rounded-md shadow-lg !z-50">
                      <div className="flex justify-between mb-4 border-b border-secondary-100 pb-2">
                        <DialogTitle as="h2" className="text-xl font-bold">
                          Invoice
                        </DialogTitle>
                        <button onClick={handleCloseTotalBillModal}>
                          <XMarkIcon className="h-6 w-6" />
                        </button>
                      </div>
                      <span className="text-sm font-medium leading-5 text-left text-text-color">
                        <div className="flex flex-col space-y-4">
                          <div className="w-full mx-auto">
                            {bookingDetails?.invoice?.breakdown?.fleet &&
                              Object.keys(
                                bookingDetails.invoice.breakdown.fleet,
                              ).length > 0 && (
                                <div className="mt-4">
                                  <span className="text-lg font-semibold text-text-color">
                                    Trip Price
                                  </span>
                                  <div className="flex justify-between ">
                                    <span
                                      className="truncate max-w-[60%]"
                                      title={
                                        bookingDetails?.invoice?.breakdown
                                          ?.fleet?.name
                                      }
                                    >
                                      {
                                        bookingDetails?.invoice?.breakdown
                                          ?.fleet?.name
                                      }
                                    </span>
                                    <div className="flex flex-col items-end">
                                      <span className="text-xl font-medium text-text-color">
                                        $
                                        {Number(
                                          bookingDetails?.invoice?.breakdown
                                            ?.fleet?.total,
                                        ).toFixed(2)}
                                      </span>
                                      <span className="text-sm text-text-color">
                                        $
                                        {
                                          bookingDetails?.invoice?.breakdown
                                            ?.fleet?.rate
                                        }
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              )}
                            {bookingDetails?.invoice?.breakdown?.locations
                              .length > 0 && (
                              <div className="mt-4">
                                <span className="text-lg font-semibold text-text-color">
                                  Location Total
                                </span>
                                {bookingDetails?.invoice?.breakdown?.locations?.map(
                                  (location: any) => (
                                    <>
                                      <div className="flex justify-between ">
                                        <span
                                          className="truncate max-w-[60%]"
                                          title={location.name}
                                        >
                                          {location.name}
                                        </span>
                                        <div className="flex flex-col items-end">
                                          <span className="text-xl font-medium text-text-color">
                                            $
                                            {Number(location?.total).toFixed(2)}
                                          </span>
                                        </div>
                                      </div>
                                    </>
                                  ),
                                )}
                              </div>
                            )}

                            {bookingDetails?.invoice?.breakdown?.insurance
                              .length > 0 && (
                              <div className="mt-4">
                                <span className="text-lg font-semibold text-text-color">
                                  Insurance Total
                                </span>

                                {bookingDetails?.invoice?.breakdown?.insurance?.map(
                                  (insurance: any) => (
                                    <>
                                      <div className="flex justify-between ">
                                        <span
                                          className="truncate max-w-[60%]"
                                          title={insurance?.name}
                                        >
                                          {insurance?.name}
                                        </span>
                                        <div className="flex flex-col items-end">
                                          <span className="text-xl font-medium text-text-color">
                                            $
                                            {Number(insurance?.total).toFixed(
                                              2,
                                            )}
                                          </span>
                                          <span className="text-sm text-text-color">
                                            {insurance?.rate}
                                          </span>
                                        </div>
                                      </div>
                                    </>
                                  ),
                                )}
                              </div>
                            )}

                            {bookingDetails?.invoice?.breakdown?.extras.length >
                              0 && (
                              <div className="mt-4">
                                <span className="text-lg font-semibold text-text-color">
                                  Trip Extras
                                </span>

                                {bookingDetails?.invoice?.breakdown?.extras?.map(
                                  (extra: any) => (
                                    <>
                                      <div className="flex justify-between ">
                                        <span
                                          className="truncate max-w-[60%]"
                                          title={extra.name}
                                        >
                                          {extra.name}
                                        </span>
                                        <div className="flex flex-col items-end">
                                          <span className="text-xl font-medium text-text-color">
                                            ${Number(extra.total).toFixed(2)}
                                          </span>
                                          <span>${extra.rate}</span>
                                        </div>
                                      </div>
                                    </>
                                  ),
                                )}
                              </div>
                            )}

                            {bookingDetails?.invoice?.breakdown?.booking_fee
                              .length > 0 && (
                              <div className="mt-4">
                                <div className="pb-4">
                                  <span className="text-lg font-semibold text-text-color">
                                    Booking Fee
                                  </span>
                                </div>
                                {bookingDetails?.invoice?.breakdown?.booking_fee?.map(
                                  (bookingFee: any) => (
                                    <>
                                      <div className="flex justify-between ">
                                        <span
                                          className="truncate max-w-[60%]"
                                          title={
                                            bookingFee.description
                                              ? bookingFee.description
                                              : bookingFee.name
                                          }
                                        >
                                          {bookingFee.description
                                            ? bookingFee.description
                                            : bookingFee.name}
                                        </span>
                                        <div className="flex flex-col items-end">
                                          <span className="text-xl font-medium text-text-color">
                                            $
                                            {Number(bookingFee.total).toFixed(
                                              2,
                                            )}
                                          </span>
                                          <span>
                                            {bookingFee.rate.includes("%")
                                              ? bookingFee.rate
                                              : `$${bookingFee.rate}`}
                                          </span>
                                        </div>
                                      </div>
                                    </>
                                  ),
                                )}
                              </div>
                            )}

                            {bookingDetails?.invoice?.breakdown?.taxes.length >
                              0 && (
                              <div className="mt-4">
                                <span className="text-lg font-semibold text-text-color">
                                  Tax & Fee
                                </span>
                                {bookingDetails?.invoice?.breakdown?.taxes?.map(
                                  (taxes: any) => (
                                    <>
                                      <div className="flex justify-between ">
                                        <span
                                          className="truncate max-w-[60%]"
                                          title={
                                            taxes.description
                                              ? taxes.description
                                              : taxes.name
                                          }
                                        >
                                          {taxes.description
                                            ? taxes.description
                                            : taxes.name}
                                        </span>
                                        <div className="flex flex-col items-end">
                                          <span className="text-xl font-medium text-text-color">
                                            ${Number(taxes.total).toFixed(2)}
                                          </span>
                                          <span>
                                            {taxes.rate.includes("%")
                                              ? taxes.rate
                                              : `$${taxes.rate}`}
                                          </span>
                                        </div>
                                      </div>
                                    </>
                                  ),
                                )}
                              </div>
                            )}

                            {bookingDetails?.invoice?.coupon_info?.id && (
                              <div className="mt-4">
                                <span className="text-lg font-semibold text-text-color">
                                  Coupon
                                </span>

                                <>
                                  <div className="flex justify-between ">
                                    <span
                                      className="truncate max-w-[60%]"
                                      title={
                                        bookingDetails?.invoice?.coupon_info
                                          ?.name
                                      }
                                    >
                                      {
                                        bookingDetails?.invoice?.coupon_info
                                          ?.name
                                      }
                                    </span>
                                    <div className="flex flex-col items-end">
                                      <span className="text-xl font-medium text-text-color">
                                        $
                                        {
                                          bookingDetails?.invoice
                                            ?.coupon_discount
                                        }
                                      </span>
                                      <span>
                                        {bookingDetails?.invoice?.coupon_info?.coupon_type.includes(
                                          "percentage",
                                        )
                                          ? bookingDetails?.invoice?.coupon_info
                                              ?.amount + "%"
                                          : `$${bookingDetails?.invoice?.coupon_info?.amount}`}
                                      </span>
                                    </div>
                                  </div>
                                </>
                              </div>
                            )}

                            {(bookingDetails?.invoice?.breakdown?.discount &&
                              Object.keys(
                                bookingDetails?.invoice?.breakdown?.discount,
                              ).length > 0) ||
                            bookingDetails?.invoice?.discount !== "0.00" ? (
                              <>
                                {bookingDetails?.invoice?.breakdown?.discount &&
                                Object.keys(
                                  bookingDetails?.invoice?.breakdown?.discount,
                                ).length > 0 ? (
                                  <div className="mt-4">
                                    <div className="flex justify-between ">
                                      <span className="text-lg font-semibold text-text-color">
                                        Discount
                                      </span>

                                      <div className="flex flex-col items-end">
                                        <span className="text-xl font-medium text-text-color">
                                          -$
                                          {Math.abs(
                                            Number(
                                              Number(
                                                bookingDetails?.invoice
                                                  ?.breakdown?.discount?.total,
                                              ).toFixed(2),
                                            ),
                                          )}
                                        </span>
                                        <span>
                                          {
                                            bookingDetails?.invoice?.breakdown
                                              ?.discount?.rate
                                          }
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  bookingDetails?.invoice?.discount !==
                                    "0.00" && (
                                    <>
                                      <div className="mt-4">
                                        <div className="flex justify-between ">
                                          <span className="text-lg font-normal text-text-color">
                                            Discount
                                          </span>
                                          <span className="text-xl font-medium text-text-color">
                                            -$
                                            {Math.abs(
                                              Number(
                                                bookingDetails?.invoice?.discount.toFixed(
                                                  2,
                                                ),
                                              ),
                                            )}
                                          </span>
                                        </div>
                                      </div>
                                    </>
                                  )
                                )}
                              </>
                            ) : null}
                            {bookingDetails?.invoice?.breakdown?.other?.length >
                              0 && (
                              <div className="mt-4">
                                <span className="text-lg font-semibold text-text-color">
                                  Others
                                </span>
                                {bookingDetails?.invoice?.breakdown?.other?.map(
                                  (other: any) => (
                                    <div
                                      key={other.name}
                                      className="flex justify-between"
                                    >
                                      <span
                                        className="truncate max-w-[60%]"
                                        title={other.name}
                                      >
                                        {other.name}
                                      </span>
                                      <div className="flex flex-col items-end">
                                        <span className="text-xl font-medium text-text-color">
                                          ${Number(other.total).toFixed(2)}
                                        </span>
                                        <span>${other.rate}</span>
                                      </div>
                                    </div>
                                  ),
                                )}
                              </div>
                            )}

                            <div className="mt-8 border-secondary-100 pt-4">
                              <div className="flex justify-between ">
                                <div>
                                  <span className="text-lg font-semibold text-text-color">
                                    Total Rental Price
                                  </span>
                                  <p className="mt-1 text-sm text-text-color">
                                    Overall price rental
                                  </p>
                                </div>
                                <div>
                                  <span className="text-xl font-medium text-text-color">
                                    $
                                    {bookingDetails?.final_price_without_security.toFixed(
                                      2,
                                    )}
                                  </span>
                                </div>
                              </div>
                            </div>

                            {bookingDetails?.final_security_deposit !== 0 && (
                              <div className="mt-4">
                                <div className="flex justify-between ">
                                  <span className="text-lg font-semibold text-text-color">
                                    Refundable Deposit
                                  </span>
                                  <span className="text-xl font-medium text-text-color">
                                    $
                                    {bookingDetails?.final_security_deposit.toFixed(
                                      2,
                                    )}
                                  </span>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </span>
                    </DialogPanel>
                  </TransitionChild>
                </div>
              </div>
            </Dialog>
          </Transition>

          <main className="container mt-11 mb-24 lg:mb-32 ">
            <div className="max-w-6xl mx-auto">
              {bookingloading ? (
                <div className="flex justify-center items-center col-span-full py-96">
                  <div className="spinner-border animate-spin inline-block w-6 h-6 border-4 rounded-full border-t-transparent border-gray-300"></div>
                </div>
              ) : bookingDetails !== null ? (
                <>
                  {renderContent()}
                  {isEdit && (
                    <EditBooking
                      startTime={startTime}
                      setStartTime={setStartTime}
                      endTime={endTime}
                      setEndTime={setEndTime}
                      bookingDetails={bookingDetails}
                      fetchBookingDetail={fetchBookingDetail}
                      onClose={handleCloseEdit}
                    />
                  )}
                  {bookingDetails?.trip_status !== "cancelled" &&
                  bookingDetails?.cancellation_pending !== true
                    ? renderBookingDetailsSection()
                    : renderCancelBookingSection()}
                </>
              ) : (
                rendernoBooking()
              )}
            </div>
          </main>
        </div>
      )}

      <Transition appear show={isCancellationOpen} as={Fragment}>
        <Dialog
          as="div"
          className="HeroSearchFormMobile__Dialog relative z-50"
          onClose={() => {
            setIsCancellationOpen(false);
          }}
          static={true}
        >
          <div className="fixed inset-0 bg-neutral-100 dark:bg-[#333333]">
            <div className="flex h-full">
              <TransitionChild
                as={Fragment}
                enter="ease-out transition-transform"
                enterFrom="opacity-0 translate-y-52"
                enterTo="opacity-100 translate-y-0"
                leave="ease-in transition-transform"
                leaveFrom="opacity-100 translate-y-0"
                leaveTo="opacity-0 translate-y-52"
              >
                <DialogPanel className="relative h-full w-full overflow-hidden flex-1 flex flex-col justify-between ">
                  <>
                    <div className="absolute left-4 top-4 z-0">
                      <button
                        className="focus:outline-none focus:ring-0"
                        onClick={close}
                      >
                        <XMarkIcon
                          onClick={() => {
                            setIsCancellationOpen(false);
                            setIsCancelModalOpen(true);
                          }}
                          className="w-5 h-5 text-black dark:text-white"
                        />
                      </button>
                    </div>

                    <div className="flex-1 pt-12 p-1 flex flex-col overflow-auto">
                      <div className="flex-1 flex flex-col bg-white dark:bg-[#333333] z-10">
                        <div className="flex-1 flex flex-col transition-opacity animate-[myblur_0.4s_ease-in-out] overflow-auto">
                          <Cancellation terms={cancellationPolicy} />
                        </div>
                      </div>
                    </div>
                    <div className=" justify-end px-4 py-3 bg-white dark:bg-[#333333] border-t border-neutral-200 dark:border-[#FFFFFF33] flex">
                      <ButtonPrimary
                        sizeClass="px-6 py-3 !rounded-lg"
                        onClick={() => {
                          setIsCancellationOpen(false);
                          setCancellationPolicyChecked(true);
                          setIsCancelModalOpen(true);
                        }}
                      >
                        Accept
                      </ButtonPrimary>
                    </div>
                  </>
                </DialogPanel>
              </TransitionChild>
            </div>
          </div>
        </Dialog>
      </Transition>

      <Transition appear show={isCancelModalOpen}>
        <Dialog as="div" className="relative z-50" onClose={() => {}}>
          <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
          <div className="fixed inset-0 z-50 w-screen overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4">
              <TransitionChild
                enter="ease-out duration-300"
                enterFrom="opacity-0 transform-[scale(95%)]"
                enterTo="opacity-100 transform-[scale(100%)]"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 transform-[scale(100%)]"
                leaveTo="opacity-0 transform-[scale(95%)]"
              >
                <DialogPanel className="w-full max-w-md bg-white dark:bg-[#111111] rounded-xl p-6 shadow-2xl">
                  <div className="flex justify-between items-center mb-4">
                    <DialogTitle
                      as="h3"
                      className="text-xl font-bold text-text-color"
                    >
                      Cancel Booking
                    </DialogTitle>
                    <button
                      onClick={() => setIsCancelModalOpen(false)}
                      className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
                    >
                      <XMarkIcon className="h-6 w-6" />
                    </button>
                  </div>

                  <p className="text-gray-600 dark:text-gray-400 mb-6">
                    Are you sure you want to cancel your booking? This action
                    cannot be undone.
                  </p>

                  <div className="flex gap-2 mt-4 p-4 border border-neutral-200 dark:border-[#FFFFFF33] rounded-md overflow-hidden z-10">
                    <Checkbox
                      checked={cancellationPolicyChecked}
                      onChange={(checked) => {
                        if (checked) {
                          setIsCancellationOpen(true);
                          setIsCancelModalOpen(false);
                        } else {
                          setCancellationPolicyChecked(false);
                          setIsCancelModalOpen(true);
                        }
                      }}
                      className="group size-7 rounded-md p-1 ring-1 ring-primary-200 data-[checked]:bg-primary-200 data-[checked]:bg-opacity-20 ring-inset  mr-4"
                    >
                      <CheckIcon
                        className={`size-5 stroke-white ${
                          cancellationPolicyChecked ? "visible" : "invisible"
                        }`}
                      />
                    </Checkbox>
                    <div>
                      <div className="text-gray-400 text-lg font-medium">
                        I hereby confirm that I have read, understood, and
                        accept the{" "}
                        <span
                          className="text-gray-800 dark:text-white text-xl font-bold cursor-pointer underline"
                          onClick={() => {
                            setIsCancellationOpen(true);
                            setIsCancelModalOpen(false);
                          }}
                        >
                          Cancellation Policy.
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="flex gap-3 justify-end mt-6">
                    <ButtonPrimary
                      onClick={() => setIsCancelModalOpen(false)}
                      disabled={isCancelling}
                      className="!border !bg-transparent !rounded-lg hover:!bg-white text-text-color"
                    >
                      No
                    </ButtonPrimary>
                    <ButtonPrimary
                      onClick={handleCancelBooking}
                      className="!border-none !rounded-lg"
                    >
                      {isCancelling ? (
                        <div className="flex items-center gap-2">
                          <div className="spinner-border animate-spin inline-block w-4 h-4 border-2 rounded-full border-t-transparent border-white"></div>
                        </div>
                      ) : (
                        "Yes"
                      )}
                    </ButtonPrimary>
                  </div>
                </DialogPanel>
              </TransitionChild>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default BookingDetailPage;
